import { Link } from "react-router-dom";
import { ArrowRight, Bike, Music } from "lucide-react";
import { DeliveryBadges } from "./DeliveryBadges";
import { PICKUP_REASON } from "../data/nap";
import { useCart } from "../context/CartContext";

const NOTES = [
  { dur: "4.2s", delay: "0s", dx1: "12px", dx2: "-6px", dx3: "20px", spin: 1, size: 14 },
  { dur: "5s", delay: "1.1s", dx1: "-14px", dx2: "2px", dx3: "-22px", spin: -1, size: 12 },
  { dur: "4.6s", delay: "2.3s", dx1: "6px", dx2: "22px", dx3: "10px", spin: 1, size: 15 },
  { dur: "5.4s", delay: "3.2s", dx1: "-8px", dx2: "-20px", dx3: "-2px", spin: -1, size: 11 },
];

// Notes rise out of the button's own icon and drift like butterflies (CSS only, disabled under reduced-motion).
function MusicNotes() {
  return (
    <span className="music-notes" data-testid="music-notes" aria-hidden="true">
      <Music size={16} />
      {NOTES.map((n, i) => (
        <Music key={i} size={n.size} strokeWidth={2.6} className="music-note"
          style={{ "--dur": n.dur, "--delay": n.delay, "--dx1": n.dx1, "--dx2": n.dx2, "--dx3": n.dx3, "--spin": n.spin }} />
      ))}
    </span>
  );
}

// Pickup = our checkout (primary). Delivery = our own courier when it's on (app badges only while delivery is paused).
export function OrderCtas({ pickupTo = "/store/restaurant", compact = false, testPrefix = "cta", showMusic = false }) {
  const { deliveryInfo, setChannel } = useCart();
  const size = compact ? "text-xs px-4 py-2" : "text-sm px-6 py-3";
  return (
    <div data-testid={`${testPrefix}-order-ctas`}>
      <div className="flex flex-wrap items-center gap-3">
        <Link to={pickupTo} data-testid={`${testPrefix}-order-pickup`}
          className={`inline-flex items-center gap-2 bg-[#db594b] hover:bg-[#c34a3e] text-white font-bold ${size} rounded-full transition-colors`}>
          Order pickup — direct from us <ArrowRight size={16} aria-hidden="true" />
        </Link>
        {showMusic && (
          <Link to="/music" data-testid={`${testPrefix}-music-link`}
            className={`inline-flex items-center gap-2 bg-[#e0a458] hover:bg-[#d3943f] text-neutral-900 font-bold ${size} rounded-full shadow-sm transition-colors`}>
            <MusicNotes /> Music by VeerGi
          </Link>
        )}
      </div>
      <p className="text-xs text-neutral-500 mt-2" data-testid={`${testPrefix}-pickup-reason`}>{PICKUP_REASON}</p>
      <div className="mt-3">
        {deliveryInfo?.available ? (
          <Link to={pickupTo} onClick={() => setChannel("delivery")} data-testid={`${testPrefix}-delivery-direct`}
            className="inline-flex items-center gap-1.5 text-xs font-bold text-[#E04F33] hover:underline">
            <Bike size={14} aria-hidden="true" /> Delivery direct from us{deliveryInfo.customer_fee != null ? ` — $${Number(deliveryInfo.customer_fee).toFixed(2)}` : ""}
          </Link>
        ) : <DeliveryBadges testPrefix={`${testPrefix}-delivery`} />}
      </div>
    </div>
  );
}
